import { render } from "./SenhaEmail.vue?vue&type=template&id=00442880&scoped=true"
import script from "./SenhaEmail.vue?vue&type=script&lang=js"
export * from "./SenhaEmail.vue?vue&type=script&lang=js"

import "./SenhaEmail.vue?vue&type=style&index=0&id=00442880&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00442880"]])

export default __exports__